<template>
    <button type="button" class="btn float-end btn-outline-success" data-bs-toggle="modal"
        :data-bs-target="`#${modalId}`">
        <slot></slot>
    </button>

    <Teleport to="body">
        <div class="modal fade" :id="modalId" tabindex="-1" :aria-labelledby="`${modalId}-label`" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 :id="`${modalId}-label`">设置</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <input type="text" class="form-control" placeholder="开发中....">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">关闭</button>
                        <button type="button" data-bs-dismiss="modal" class="btn btn-primary">确认</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
import { getCurrentInstance } from 'vue';

export default {
    setup() {
        const instance = getCurrentInstance();
        const modalId = `settings-modal-${instance.uid}`;

        return {
            modalId,
        };
    },
};
</script>
